import { cx } from '@linaria/core';
import { useElementHeight } from '../hooks/useElementHeight.js';
import { boundaryTokens, aspectCls, contentCls, boundaryCls } from './styles/Boundary.js';
import { jsx } from 'react/jsx-runtime';

function Boundary({
  children,
  captionRef,
  dimensions,
  enableScaling,
  inLightbox
}) {
  const maxWidth = enableScaling ? undefined : dimensions?.maxWidth;
  const captionHeight = useElementHeight({
    elementRef: captionRef
  });
  return /*#__PURE__*/jsx("span", {
    className: cx(boundaryCls, inLightbox && "inLightbox"),
    style: boundaryTokens.__override({
      maxWidth: maxWidth && `${maxWidth}px`,
      aspectRatio: dimensions?.aspectRatio,
      captionHeight: `${captionHeight}px`
    }),
    children: /*#__PURE__*/jsx("span", {
      className: aspectCls,
      children: /*#__PURE__*/jsx("span", {
        className: contentCls,
        children: children
      })
    })
  });
}

export { Boundary };
//# sourceMappingURL=Boundary.js.map
